import types from '../type';
/**
 * 日期格式化
 * @param {string} fmt 格式化模式 (见dateFormats对象)
 * @param {Date} date 日期对象
 * eg: 2020-07-24 18:37:10
 * 年：yyyy -> 2020,  yy ->  20 (取后两位)
 * 月：MM ->  07, MMM -> Jul, MMMM -> July
 * 日：dd ->  24
 * 星期：ww ->  Fri
 * 时: HH ->  18, hh -> 06(12小时制)
 * 分: mm -> 37
 * 秒: ss -> 10
 * 毫秒：sss
 * p： PM or AM
 */
export default function format(fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date()) {
    if(typeof date === 'string' && date){
        // 兼容字符串的 - 分割
        date = date.replace(/-/g,"/");
    }
    date = new Date(date);

    var fmts = fmt.match(/(\w)\1*/g).sort();
    for (var i = fmts.length - 1; i >= 0; i--) {
        let fmtValue = dateFormats[fmts[i]] && dateFormats[fmts[i]].call(date);
        if (types.isNull(fmtValue)) {
            continue;
        }
        if (!isNaN(fmtValue) && fmtValue < 10) {
            fmtValue = '0' + fmtValue;
        }
        fmt = fmt.replace(fmts[i], fmtValue);
    }
    return fmt;
}

export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const MONTH_SIMPLE_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
export const WEEK_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const dateFormats = {
    yyyy: function () {
        return this.getFullYear();
    },
    yy: function () {
        return this.getFullYear() % 100;
    },
    MM: function () {
        return this.getMonth() + 1;
    },
    MMM: function () {
        return MONTH_SIMPLE_NAMES[this.getMonth()];
    },
    MMMM: function () {
        return MONTH_NAMES[this.getMonth()];
    },
    dd: function () {
        return this.getDate();
    },
    ww: function () {
        return WEEK_NAMES[this.getDay()];
    },
    HH: function () {
        return this.getHours();
    },
    hh: function () {
        var hour = this.getHours();
        return hour <= 12 ? (hour === 0 ? 12 : hour) : hour - 12;
    },
    mm: function () {
        return this.getMinutes();
    },
    ss: function () {
        return this.getSeconds();
    },
    sss: function () {
        return this.getMilliseconds();
    },
    p: function () {
        return this.getHours() >= 12 ? 'PM' : 'AM';
    }
};
